import { defineMessages } from 'react-intl';

export default defineMessages({
    dueDate: {
        id: 'billing.invoices-table.Due Date',
        defaultMessage: 'Due Date'
    },
    billStatus: {
        id: 'billing.invoices-table.Bill Status',
        defaultMessage: 'Bill Status'
    },
    lastPaymentDate: {
        id: 'billing.invoices-table.Date Payment Received',
        defaultMessage: 'Date Payment Received'
    },
    invoiceTotal: {
        id: 'billing.invoices-table.Invoice Total',
        defaultMessage: 'Invoice Total'
    },
    paid: {
        id: 'billing.invoices-table.Paid',
        defaultMessage: 'Paid'
    },
    outstanding: {
        id: 'billing.invoices-table.Outstanding',
        defaultMessage: 'Outstanding'
    },
    invoice: {
        id: 'billing.invoices-table.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    pay: {
        id: 'billing.invoices-table.Pay',
        defaultMessage: 'Pay'
    },
    noMatchingPayments: {
        id: 'billing.invoices-table.No matching payments.',
        defaultMessage: 'No matching payments.'
    },
    policyTerm: {
        id: 'billing.invoices-table.Policy Term',
        defaultMessage: 'Policy Term'
    },
    balanceDue: {
        "id": "billing.invoices-table.Balance Due",
        "defaultMessage": "Balance Due"
      }
});
